import { RouterProvider } from "react-router-dom";
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { logger } from "@/lib/logger";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./app/auth";
import { supabaseConfigured } from "@/lib/supabase";
import { router } from "./app/router";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
  // Une requête de lecture qui échoue ne doit jamais passer pour « aucune donnée » :
  // on la journalise (Console) et les écrans l'affichent.
  queryCache: new QueryCache({ onError: (error, query) => logger.error(`Lecture impossible : ${query.queryKey[0] as string}`, error, { queryKey: query.queryKey }) }),
});

export default function App() {
  if (!supabaseConfigured) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground">
        <div className="max-w-md rounded-xl border border-border bg-card p-8 text-center">
          <div className="font-heading text-2xl font-extrabold">IRONCLIC CRM</div>
          <p className="mt-3 text-sm text-muted-foreground">Installation en cours — le backend n'est pas encore relié à cette version.</p>
        </div>
      </div>
    );
  }
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
